export default "__VITE_ASSET__ddc1d79b__"